const Director = 'Director'
const Manager = 'Manager'
const SalesExecutive = 'SalesExecutive'
const CreditAnalyst = 'CreditAnalyst'

export default [
  {
    path: '/economic_groups/create',
    name: 'CreateEconomicGroup',
    component: () => import('@/_backoffice/_registrations/components/economic_groups/CreateEconomicGroup.vue'),
    meta: {
      auth: true,
      roles: [Director, SalesExecutive, Manager, CreditAnalyst],
    },
  },
  {
    path: '/economic_groups',
    name: 'EconomicGroups',
    component: () => import('@/_backoffice/_registrations/components/economic_groups/EconomicGroups.vue'),
    meta: {
      auth: true,
      roles: [Director, SalesExecutive, Manager, CreditAnalyst],
    },
    children:[
      {
        path: ':id',
        name: 'ShowEconomicGroup',
        component: () => import('@/_backoffice/_registrations/components/economic_groups/ShowEconomicGroup.vue'),
        meta: {
          auth: true,
          roles: [Director, SalesExecutive, Manager, CreditAnalyst]
        },
      },
    ]
  },
]



